<template>
    <div id="clients_create_page" class="container-fluid">
        <form>
            <div class="form-group">
                <label for="client_name">CLIENT NAME</label>
                <input v-model="client_name" type="text" class="form-control col-md-5 col-lg-4 col-xl-3" id="client_name" autofocus>
            </div>

            <div class="form-group">
                <label>PROJECT MANAGER</label>
                <div class="col-md-3 col-lg-2 padding-x0">
                    <v-select v-model="project_manager" :reduce="user => user.id" label="full_name" :options="users"></v-select>
                </div>
            </div>

            <div class="form-group">
                <div class="row padding-x10">
                    <div class="col-xs-4">
                        <div class="report-image">
                            <img v-if="report_image_loaded" :src="report_image_loaded" height="65">
                        </div>
                    </div>

                    <div class="col-xs-6 margin-left20">
                        <label>UPLOAD REPORT IMAGE</label>
                        <div>
                            <input @change="reportImageChanged" id="report_image" type="file" class="form-control hidden" name="report_image" accept="image/x-png,image/gif,image/jpeg">
                        </div>

                        <span class="input-wrap text-left">
                            <button type="button" id="file-browse" class="btn btn-info reverse" @click="browse">Browse</button>
                        </span>
                    </div>
                </div>
            </div>

            <div v-if="all_data_connection_accounts" class="form-group">
                <div class="padding-bottom30">
                    <h5 class="pull-left margin-bottom0">Choose which accounts to use from your data connections</h5>

                    <div class="pull-right">
                        <input @input="filterDataConnectionAccounts" type="text" placeholder="Search accounts..." class="form-control search-accounts">
                    </div>
                </div>

                <div id="select_accounts">
                    <div v-for="(data_connection_accounts, data_source_name) in all_data_connection_accounts" class="card">
                        <div class="card-header" :id="`data_connection_accounts_${data_connection_accounts[0].abbreviation}`">
                            <div class="row">
                                <div class="col-4">
                                    <img class="d-inline-block" :src="`${$store.state.app_url}images/data_sources/${data_connection_accounts[0].abbreviation}.png`">
                                    <h5 class="mb-0 mt-1 d-inline-block">{{ data_source_name }}</h5>
                                </div>
                                <div class="col-4">
                                    <h5 class="mt-1">Profiles ({{ data_connection_accounts.length }})</h5>
                                </div>
                                <div class="col-4">
                                    <button
                                        type="button"
                                        class="btn btn-info reverse pull-right"
                                        data-toggle="collapse"
                                        :data-target="`#collapse_${data_connection_accounts[0].abbreviation}`"
                                        aria-expanded="true"
                                        :aria-controls="`collapse_${data_connection_accounts[0].abbreviation}`">
                                        View
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div :id="`collapse_${data_connection_accounts[0].abbreviation}`" class="collapse" :aria-labelledby="`data_connection_accounts_${data_connection_accounts[0].abbreviation}`" data-parent="#select_accounts">
                            <div class="card-body padding-y0">
                                <v-client-table :data="data_connection_accounts" :columns="select_accounts_columns" :options="select_accounts_options">
                                    <button @click="connectOrDisconnect(props.row.id)" slot="actions" slot-scope="props" type="button" class="btn reverse pull-right" :class="selected_accounts.indexOf(props.row.id) > -1 ? 'btn-danger' : 'btn-info'">
                                        {{ selected_accounts.indexOf(props.row.id) > -1 ? 'Disconnect' : 'Connect' }}
                                    </button>
                                </v-client-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="form-group">
                <div class="padding-bottom30">
                    <h5 class="pull-left margin-bottom0">You still have no data sources connected. Click <small><a href="../data_sources">here</a></small> to make a connection.</h5>
                </div>
            </div>
            <div class="form-group">
                <h5 class="margin-bottom10">User access</h5>

                <div class="col-12 margin-bottom10">
                    <label><p-input type="checkbox" class="p-switch p-slim users-all" id="check_all_users" @change="selectAllUsers" :checked="all_users_checked">Select all</p-input></label>
                </div>

                <div class="col-10 col-xl-6">
                    <template v-if="ai_admin_users.length">
                        <label>AI Admin</label>
                        <div class="row">
                            <template v-for="user in users">
                                <div v-if="ai_admin_users.includes(user.id)" class="col-4 mb-3">
                                    <label><p-input type="checkbox" v-model="selected_users" class="p-default p-curve single" name="selected_users[]" :value="user.id" @change="checkAll"> {{ user.full_name }}</p-input></label>
                                </div>
                            </template>
                        </div>
                    </template>
                    <template v-if="super_admin_users.length">
                        <label>Super Admin</label>
                        <div class="row">
                            <template v-for="user in users">
                                <div v-if="super_admin_users.includes(user.id)" class="col-4 mb-3">
                                    <label><p-input type="checkbox" v-model="selected_users" class="p-default p-curve single" name="selected_users[]" :value="user.id" @change="checkAll"> {{ user.full_name }}</p-input></label>
                                </div>
                            </template>
                        </div>
                    </template>
                    <template v-if="admin_users.length">
                        <label>Admin</label>
                        <div class="row">
                            <template v-for="user in users">
                                <div v-if="admin_users.includes(user.id)" class="col-4 mb-3">
                                    <label><p-input type="checkbox" v-model="selected_users" class="p-default p-curve single" name="selected_users[]" :value="user.id" @change="checkAll"> {{ user.full_name }}</p-input></label>
                                </div>
                            </template>
                        </div>
                    </template>
                    <template v-if="client_user_users.length">
                        <label>Client User</label>
                        <div class="row">
                            <template v-for="user in users">
                                <div v-if="client_user_users.includes(user.id)" class="col-4 mb-3">
                                    <label><p-input type="checkbox" v-model="selected_users" class="p-default p-curve single" name="selected_users[]" :value="user.id" @change="checkAll"> {{ user.full_name }}</p-input></label>
                                </div>
                            </template>
                        </div>
                    </template>
                </div>
            </div>

            <div class="form-group text-center">
                <button :disabled="!validateAddNewClient" id="save_client" data-loading-text='<span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>Saving...'
                        @click="saveClient" type="button" class="btn btn-info btn-lg"
                        style="pointer-events:initial !important;"
                        :title="validateAddNewClient ? '' : 'You need to complete the data setting to be able to create a client'">SAVE CHANGES</button>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        created() {
            this.fetchServerData();
        },

        mounted() {
            $(document).off('hide.bs.collapse', '#select_accounts').on('hide.bs.collapse', '#select_accounts', function(event) {
                $(event.target).prev().find('button').text('View');
            }).off('show.bs.collapse', '#select_accounts').on('show.bs.collapse', '#select_accounts', function(event) {
                $(event.target).prev().find('button').text('Hide');
            });
        },

        data() {
            return {
                client_name:                  '',
                selected_currency:            3, // Hardcoded to USD for now
                project_manager:              '',
                currencies:                   [],
                report_image_loaded:          '',
                report_image:                 '',
                search_accounts_timeout:      null,
                all_data_connection_accounts: null,
                selected_accounts:            [],
                users:                        [],
                selected_users:               [],
                all_users_checked:            false,
                ai_admin_users:               [],
                super_admin_users:            [],
                admin_users:                  [],
                client_user_users:            [],

                select_accounts_columns: ['name_given_by_user', 'account_full_name', 'actions'],
                select_accounts_options: {
                    headings: {
                        name_given_by_user: '',
                        account_full_name:  '',
                        actions:            ''
                    },
                    sortable: [],

                    perPage: 10,
                    perPageValues: [],
                    texts: {
                        count: '',
                        filter: '',
                        filterPlaceholder: 'Search accounts...',
                        noResults: ''
                    },
                    skin: 'table table-borderless'
                },
                submitted:false
            }
        },

        methods: {
            fetchServerData() {
                axios.all([
                    axios.get('/api/currencies'),
                    axios.get('/api/data-connections'),
                    axios.get('/api/users')
                ])
                .then(axios.spread((currencies, dataConnectionAccounts, users) => {
                    this.currencies                   = currencies.data;
                    this.all_data_connection_accounts = dataConnectionAccounts.data;
                    this.users                        = users.data;
                    _.each(this.users, user => {
                        if(user.is_auth_user){
                            this.selected_users.push(user.id);
                        }
                        if(user.short_name == 'ai_admin'){
                            this.ai_admin_users.push(user.id);
                        }
                        if(user.short_name == 'super_admin'){
                            this.super_admin_users.push(user.id);
                        }
                        if(user.short_name == 'admin'){
                            this.admin_users.push(user.id);
                        }
                        if(user.short_name == 'client_user'){
                            this.client_user_users.push(user.id);
                        }
                    });
                }));
            },

            browse() {
                $('#report_image').click();
            },

            reportImageChanged(event) {
                const vue = this;
                let files = event.currentTarget.files;

                if (files && files[0]) {
                    var reader = new FileReader;

                    reader.onload = function(e) {
                        vue.report_image_loaded = e.target.result;
                    }

                    reader.readAsDataURL(files[0]);

                    this.report_image = files[0];
                }
            },

            filterDataConnectionAccounts(event) {
                if (this.search_accounts_timeout) {
                    clearTimeout(this.search_accounts_timeout);
                    this.search_accounts_timeout = null;
                }

                this.search_accounts_timeout = setTimeout(() => {
                    axios.get(`/api/data-connections?search_term=${event.target.value.trim()}`).then(response => {
                        this.all_data_connection_accounts = response.data;
                    });
                }, 500);
            },

            connectOrDisconnect(accountId) {
                const index = this.selected_accounts.indexOf(accountId);

                if (index === -1) {
                    this.selected_accounts.push(accountId);
                } else {
                    this.selected_accounts.splice(index, 1);
                }
            },

            selectAllUsers(event) {
                this.all_users_checked = event;
                this.selected_users = [];
                $('.single > input').prop('checked', event);

                if (event) {
                    _.each(this.users, user => {
                        this.selected_users.push(user.id);
                    });
                }
            },
            checkAll(event){
                if($('.single > input').length == $('.single > input:checked').length){
                    $('.users-all > input').prop('checked', true);
                }
                else{
                    $('.users-all > input').prop('checked', false);
                }
            },
            saveClient() {
                if(this.submitted == true) return;
                this.submitted = true;
                $('#save_client').button('loading');

                let formData = new FormData;
                formData.append('client_name', this.client_name);
                formData.append('selected_currency', this.selected_currency || '');
                formData.append('project_manager', this.project_manager || '');
                formData.append('report_image', this.report_image || '');
                formData.append('selected_accounts', this.selected_accounts.length ? JSON.stringify(this.selected_accounts) : '');
                formData.append('selected_users', this.selected_users.length ? JSON.stringify(this.selected_users) : '');

                this.ajaxSubmit({'Content-Type': 'multipart/form-data'}, 'POST', '/api/clients', formData).then(response => {
                    $('#save_client').button('reset');

                    this.$notify({
                        type: 'success',
                        text: this.messages.CLIENT_CREATED
                    });

                    setTimeout(() => {
                        this.$router.push({path: `/reports/create/client/${response.data.id}`});
                    }, 3000);
                });
            }
        },
        computed: {
            validateAddNewClient() {
                return !!(this.client_name && this.project_manager && !!this.selected_users.length && !this.submitted);
            }
        }
    }
</script>

<style lang="scss">
    @import '~@/_variables.scss';
    #clients_create_page {
        .form-group {
            margin-bottom: 2.4rem;
        }

        .data-connection-accounts {
            font-size: 1.44rem;

            td:first-child {
                font-weight: 500;
            }

            img {
                width: 3.2rem;
            }
        }

        .search-accounts {
            width: 20vw;
        }

        #select_accounts {
            clear: both;

            tr, td {
                outline: none!important;
            }

            table {
                table-layout: fixed;
                font-size: 1.44rem;

                thead {
                    display: none;
                }

                td {
                    vertical-align: middle;
                }
            }

            .VueTables__search {
                display: none;
            }

            .VuePagination {
                padding-bottom: 1rem;
            }

            img {
                width: 3.2rem;
            }
        }

        .card {
            margin-top: -0.4rem;
            border: none;
        }

        .report-image {
            background: #f1f1f1;
            width: 6.4rem;
            height: 6.4rem;
            overflow: hidden;
        }
        button:disabled{
            cursor:not-allowed;
            &:hover{
                color:white;
            }
        }
        .pretty.p-default input:checked ~ .state label::after {
            background-color:$secondary !important;
        }
        .pretty.p-switch input:checked ~ .state label::after {
            background-color:$secondary !important;
        }
        .pretty{
            line-height:1 !important;
        }
    }
</style>
